import React from 'react';
import PropTypes from 'prop-types';
import Styling from 'components/AuthStyling';
import styles from './index.module.scss';
import Button from 'components/Button';

const pwdResetsuccess = ({ history }) => {
  const login = () => {
    history.push('/login');
  };
  return (
    <Styling message="Your password has been changed successfully.">
      <div className={styles.btnContainer}>
        <Button type="button" onClick={login} text="LOGIN" />
      </div>
    </Styling>
  );
};

pwdResetsuccess.propTypes = {
  history: PropTypes.object.isRequired,
};

export default pwdResetsuccess;
